<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import api from "../../../services/api";
import Carousel from "../../../components/carousel";
import {Newspaper} from "@/services/models";
import ModalTree from "@/components/modal-tree.vue";
import ScrollLoad from "@/components/scroll-load.vue";

export default {
  page: {
    title: "Journal",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    ScrollLoad,
    ModalTree,
    Carousel,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Journal",
      items: [
        {
          text: "Journal",
          active: true
        },
        {
          text: "Liste",
          active: true
        }
      ],
      imagesJournal: [],
      displayedImages: [],
      singleImage: false,
      currentPage: 1,
      total: 0,
      itemsByPage: 6,
      showSlider: false,
      slide: 0,
      filter: null,
      isFetchingNextImages: true,
      selected: null,
      showModal: false,
      componentsModal: []
    };
  },
  mounted() {
    this.getImagesJournal();
  },
  methods: {
    getImagesJournal() {
      this.isFetchingNextImages = true;

      api.getModels(Newspaper, {
        params: {
          page: this.currentPage,
          length: this.itemsByPage,
          sortBy: 'filename',
          sortDir: 'asc',
          filter: this.filter,
          with: 'events.persons'
        },
        identifier: 'provider'
      }).then(result => {
        for (const i in result.data.data) {
          this.displayedImages.push(result.data.data[i]);
        }

        this.total = result.data.total;
      }).finally(() => {
        this.isFetchingNextImages = false;
      });
    },
    getImagePath(item, thumbnail) {
      try {
        return [{
          src: '/api/newspapers/' + item.id + '/' + (thumbnail ? 'thumbnail' : 'image'),
          title: item.filename
        }];
      } catch (e) {
        return [{
          src: require(`@/assets/images/missing-img.svg`),
          title: 'missing-img'
        }];
      }
    },
    search() {
      this.displayedImages = [];
      this.currentPage = 1;
      this.total = 0;
      this.getImagesJournal();
    },
    selectSlide(item) {
      this.selected = item;
      this.slide = this.displayedImages.findIndex(v => v.id === item.id);
      this.showSlider = true;
    },
    showModel(v) {
      this.componentsModal = [v.detail()];
      this.showModal = true;
    },
  },
  watch: {
    filter() {
      this.search();
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <b-card>
      <b-card-body>
        <div class="row pb-4">
          <div class="col-md-12">
            <div id="tickets-table_filter" class="dataTables_filter text-right">
              <label class="d-inline-flex align-items-center">
                Recherche :
                <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Recherche..."
                    class="form-control-sm w-auto"
                ></b-form-input>
              </label>
            </div>
          </div>
        </div>

        <b-row>
          <b-col md="6" v-for="(imageJournal, index) in displayedImages" :key="index"
                 :style="(index%2===0?'border-right: 1px solid;':'')+'border-bottom: 1px solid;'">
            <div class="mb-0" @click="selectSlide(imageJournal)" role="button">
              <b-row no-gutters class="align-items-center">
                <b-col cols="12">
                  <b-card-img-lazy :src="getImagePath(imageJournal)[0].src" class="img-fluid"></b-card-img-lazy>
                </b-col>
                <b-col cols="12">
                  <b-card-body>
                    <b-card-title>
                      <h5 class="card-title text-center">{{ imageJournal.filename }}</h5>
                    </b-card-title>
                  </b-card-body>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer class="text-center">
        <scroll-load v-model="currentPage" :total-rows="total" :per-page="itemsByPage" :loading="isFetchingNextImages"
                     @input="getImagesJournal()"></scroll-load>
      </b-card-footer>
    </b-card>

    <b-modal centered hide-footer size="xl" v-model="showSlider">
      <carousel :pages="displayedImages" type="newspapers" :set-slide="slide"></carousel>

      <blockquote v-if="selected && selected.events.length !== 0">
        Événements :
        <template v-for="(model, k) in selected.events">
          <span :key="model.CodeEvenement" @click="showModel(model)" class="hover-cursor-pointer">{{ model }}</span>
          <template v-if="k + 1 !== selected.events.length">, </template>
        </template>
      </blockquote>
    </b-modal>

    <modal-tree v-model="showModal" :tree="componentsModal"></modal-tree>
  </Layout>
</template>
